<template>
  <div class="about-page">
    <div class="about-page__text">
      <div class="texts">
        A. Residence объединяет 5 особняков, расположенных на Садовнической
        улице в атмосферном районе Замоскворечья на собственной приватной
        территории.
      </div>
      <div class="_img">
        <img :src="require('@/assets/img/about/1.jpg')" alt="" />
      </div>
    </div>

    <TabsSlider
      v-for="about in this.$store.getters.getAbout"
      :key="about.id"
      :texts="about.texts"
      :photos="about.gallery"
    />

    <InteractForm />
  </div>
</template>

<script>
import InteractForm from "@/components/Interact.vue"
import TabsSlider from "@/components/TabsSlider.vue"

export default {
  name: "About",
  data() {
    return {}
  },
  methods: {},
  mounted() {
    window.scrollTo(0, 0)
  },
  components: {
    TabsSlider,
    InteractForm,
  },
}
</script>
